<template>
	<div v-show="season || user.contributer">
		<div id="season-detail__wrapper">
			<div class="season-block season-poster__box">
				<img :src="baseUrl + season.season_poster" class="rounded mt-5" />
				<div class="movie-info__block">
					<v-dialog v-if="season.images != ''" v-model="archiveImageDialog" width="unset">
						<template v-slot:activator="{ on, attrs }">
							<v-btn block color="#0066b5" small outlined v-bind="attrs" v-on="on">архивын зургууд</v-btn>
						</template>
						<v-card>
							<v-card-title>Бүлгийн архивын зургууд:</v-card-title>
							<v-card-text>
								<v-carousel hide-delimiters show-arrows-on-hover height="auto">
									<v-carousel-item v-for="(image, index) in season.images" :key="'image' + index" :src="baseUrl + image.image">
										<v-container fill-height justify-center>
											<div class="movie-info__archive_image">{{ image.description }}</div>
										</v-container>
									</v-carousel-item>
								</v-carousel>
							</v-card-text>
							<v-card-actions class="justify-end"><v-btn text @click="archiveImageDialog = false" color="#0066b5">Хаах</v-btn></v-card-actions>
						</v-card>
					</v-dialog>
				</div>
			</div>
			<div class="season-block season-episode-list__box">
				<GenericEpisodeList :published="true" :serialSlug="serialSlug" :seasonSlug="seasonSlug" />
				<GenericEpisodeList :published="false" :serialSlug="serialSlug" :seasonSlug="seasonSlug" />
			</div>
		</div>
		<div v-if="user.isAuthenticated && user.contributer && user.adminBarHide" class="subadmin__box">
			<v-dialog v-model="publishDialog" width="500">
				<template v-slot:activator="{ on, attrs }">
					<button :class="publish ? 'subadmin__publish' : 'subadmin__unpublish'" v-bind="attrs" v-on="on"><v-icon class="subadmin__icon">mdi-clipboard-check-outline</v-icon></button>
				</template>
				<v-card>
					<v-card-title class="headline grey lighten-2 mx-auto">Бүлэг нийтлэх</v-card-title>
					<v-card-text class="mt-3">
						Та "{{ season.serial_title }}" цувралын "{{ season.season_name }}"
						<span v-if="publish">бүлгийн нийтлэгдснийг болиулах</span>
						<span v-else>бүлгийг нийтлэх</span>
						гэж байна!
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							:color="publish ? 'red' : 'primary'"
							text
							@click="
								publishDialog = false;
								publishSeason();
							"
						>
							{{ publish ? "болиулах" : "нийтлэх" }}
						</v-btn>
						<v-btn color="warning" text @click="publishDialog = false">буцах</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<router-link class="subadmin__update" :to="{ name: 'season-update', params: { serialSlug: serialSlug, seasonSlug: seasonSlug } }"><v-icon class="subadmin__icon">mdi-lead-pencil</v-icon></router-link>
			<router-link class="subadmin__image_update" :to="{ name: 'season-image-update', params: { serialSlug: serialSlug, seasonSlug: seasonSlug } }"><v-icon class="subadmin__icon">mdi-image-edit-outline</v-icon></router-link>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import Editor from "@tinymce/tinymce-vue";

import GenericEpisodeList from "@/views/season/detail/GenericEpisodeList.vue";

export default {
	props: {
		serialSlug: String,
		seasonSlug: String,
	},
	components: {
		GenericEpisodeList,
		tinymceEditor: Editor,
	},
	data() {
		return {
			commentDialog: false,
			commentTab: null,
			mediaUrl: process.env.VUE_APP_MEDIAURL,
			baseUrl: process.env.VUE_APP_BASEURL,
			season: {},
			archiveImageDialog: false,
			publish: "",
			activeTab: 0,
			publishDialog: false,
			errors: [],
			customToolbar: {
				height: 500,
				contextmenu: "link image table",
				content_style: "img {max-width: 800px;}",
				menu: {
					file: { title: "File", items: "newdocument restoredraft | preview | print | deleteallconversations" },
					edit: { title: "Edit", items: "undo redo | cut copy paste pastetext | selectall | searchreplace" },
					view: { title: "View", items: "code | visualaid visualchars visualblocks | spellchecker | fullscreen | showcomments" },
					insert: { title: "Insert", items: "image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime" },
					format: { title: "Format", items: "bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontsizes align | forecolor backcolor | removeformat" },
					tools: { title: "Tools", items: "spellchecker spellcheckerlanguage | a11ycheck code wordcount" },
					table: { title: "Table", items: "inserttable | cell row column | advtablesort | tableprops deletetable" },
				},
				images_file_types: "jpg, jpeg",
				images_upload_handler: this.uploadContentImage,
				plugins: ["advlist autolink lists link image charmap print preview anchor searchreplace visualblocks fullscreen insertdatetime media table paste wordcount imagetools"],
				toolbar: "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
			},
		};
	},
	computed: mapState(["user"]),
	methods: {
		uploadContentImage(blobInfo, success) {
			var image = blobInfo.blob();
			if (image["type"] === "image/jpeg") {
				var formData = new FormData();
				formData.append("image", image, "content-image");

				axios
					.post("/user/api/v-user-useraddimage/", formData)
					.then((result) => {
						const url = result.data.url;
						success(url);
					})
					.catch((err) => {});
			} else {
				this.$store.commit("SET_SNACK", { message: "Та JPEG өргөтгөлтэй зураг оруулна уу!", color: "red" });
			}
		},
		getSeasonDetail() {
			axios
				.get("/serial/api-season-detail/", { params: { serialSlug: this.serialSlug, seasonSlug: this.seasonSlug } })
				.then((response) => {
					(this.season = response.data.season_detail), (document.title = this.season["serial_title"] + " - " + this.season["season_name"]), (this.publish = this.season.publish);
				})
				.catch((error) => {
					if (error.response.status === 404) {
						this.$router.push({ name: "not-found-404" });
					}
				});
		},
		publishSeason() {
			if (this.user.isAuthenticated) {
				if (this.publish == false) {
					this.publish = true;
				} else {
					this.publish = false;
				}
				axios.post("/serial/api-publish-season/", { serialSlug: this.serialSlug, seasonSlug: this.seasonSlug });
			}
		},
	},
	created() {
		this.getSeasonDetail();
	},
};
</script>

<style scoped src="@/assets/styles/movie_serial.css"></style>
